export default "__VITE_ASSET__CkJc1sr9__"